import {Layout} from '../../components/LayoutComponents';

export const OverviewPage: React.FC = () => {
  return <Layout pageTitle='Übersicht' paddingBottom></Layout>;
};
